var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-6 col-md-6"},[_c('h2',[_vm._v(_vm._s(_vm.aboutsundair[_vm.getCurrentLocale]))]),_vm._v(" "),_c('p',[_c('strong'),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.aboutsundairtext[_vm.getCurrentLocale])}})]),_vm._v(" "),_c('br')])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52bffb94","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/footer/ThirdRow.vue
// module id = 362
// module chunks = 0